import Head from "next/head";
import {useRouter} from "next/router";
import {useTranslation} from "@i18n/client";
import React from "react";

import {fetchPracticeById} from "../_services/api";
import Layout from "../components/v5/Layout";
import {PracticeId} from "../constants/practiceIds";
import {withLocaleServerSideProps} from "@i18n/pages";

type Props = {
  privacyNotice: string;
};

const Privacy = ({privacyNotice}: Props) => {
  const i18n = useTranslation();
  const {
    query: {noHeaderFooter},
  } = useRouter();

  return (
    <Layout
      pageTitle={i18n.t("Notice of Privacy Practices | Carbon Health")}
      pageDescription={i18n.t("Notice of Carbon Health's Privacy Practices")}
      noHeader={!!noHeaderFooter}
      noFooter={!!noHeaderFooter}
    >
      <Head>
        <style
          dangerouslySetInnerHTML={{
            __html: `
              .hipaa h1,
              .hipaa h2,
              .hipaa h3,
              .hipaa h4,
              .hipaa p {
                font-weight: 500;
                margin-bottom: 1rem;
              }

              .hipaa ul {
                list-style: disc;
                margin: 0 1rem 1rem;
              }

              .hipaa li {
                margin: .5rem 1rem;
                line-height: 1.4;
              }

              .hipaa a {
                color: #158562;
                text-decoration: underline;
              }
            `,
          }}
        />
      </Head>
      <div
        className="hipaa pt20 ph8"
        style={{maxWidth: 1200, margin: "20px auto 40px", lineHeight: 1.4}}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: privacyNotice,
          }}
        />
      </div>
    </Layout>
  );
};

export const getServerSideProps = withLocaleServerSideProps<Props>(async () => {
  const {privacyNotice} = await fetchPracticeById(PracticeId.CARBON);

  return {
    props: {
      privacyNotice,
    },
  };
});

export default Privacy;
